import React, { createContext, useContext, ReactNode } from 'react';

interface OrderStatusContextType {
  refreshOrderStatuses: () => Promise<void>;
}

const OrderStatusContext = createContext<OrderStatusContextType | undefined>(undefined);

export const useOrderStatusContext = () => {
  const context = useContext(OrderStatusContext);
  if (!context) {
    throw new Error('useOrderStatusContext must be used within OrderStatusProvider');
  }
  return context;
};

interface OrderStatusProviderProps {
  children: ReactNode;
  refreshOrderStatuses: () => Promise<void>;
}

export const OrderStatusProvider: React.FC<OrderStatusProviderProps> = ({
  children,
  refreshOrderStatuses,
}) => {
  return (
    <OrderStatusContext.Provider value={{ refreshOrderStatuses }}>
      {children}
    </OrderStatusContext.Provider>
  );
};

